import React from "react";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export default function Bulk() {
  const { t } = useLang();
  const b = t.bulk;
  return (
    <section id="bulk" className="section-y bg-white" data-testid="bulk-section">
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <span className="overline">{b.overline}</span>
            <h2 className="mt-5 text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight text-brand-ink text-balance">
              {b.title}
            </h2>
            <p className="mt-6 text-base md:text-lg text-brand-graphite leading-relaxed text-pretty">
              {b.body}
            </p>
            <a href="/#contact" className="mt-8 inline-flex btn-primary" data-testid="bulk-cta">
              {b.cta}
              <ArrowRight className="h-4 w-4" />
            </a>
          </div>

          <div className="lg:col-span-7">
            <div className="grid gap-4 md:gap-5">
              {b.points.map((p, i) => (
                <div
                  key={i}
                  className="card-soft card-soft-hover p-6 md:p-7 flex items-start gap-6"
                  data-testid={`bulk-point-${i}`}
                >
                  <span className="font-heading text-3xl md:text-4xl font-semibold text-brand-ink/10 tracking-tight shrink-0 w-12 md:w-16">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div>
                    <div className="font-heading text-lg md:text-xl font-medium text-brand-ink">
                      {p.k}
                    </div>
                    <p className="mt-1 text-brand-graphite leading-relaxed">{p.v}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Volume tiers */}
        <div className="mt-16 md:mt-20">
          <div className="flex items-end justify-between flex-wrap gap-4">
            <h3 className="font-heading text-xl md:text-2xl font-medium text-brand-ink tracking-tight">
              {b.tiersTitle}
            </h3>
          </div>

          <div className="mt-8 grid md:grid-cols-3 gap-4 md:gap-5">
            {b.tiers.map((tier, i) => (
              <div
                key={i}
                className="card-soft card-soft-hover p-7 md:p-8 relative"
                data-testid={`bulk-tier-${i}`}
              >
                <div className="flex items-baseline justify-between">
                  <div className="font-heading text-base font-semibold tracking-wider text-brand-stone uppercase">
                    {tier.qty}
                  </div>
                  <div className="font-heading text-xs tracking-[0.22em] text-brand-champagne font-semibold">
                    {String(i + 1).padStart(2, "0")}
                  </div>
                </div>
                <div className="mt-4 font-heading text-3xl md:text-4xl font-semibold text-brand-ink tracking-tight">
                  {tier.price}
                </div>
                <p className="mt-4 text-sm text-brand-graphite leading-relaxed">{tier.body}</p>
              </div>
            ))}
          </div>

          <p className="mt-6 text-xs text-brand-stone leading-relaxed max-w-3xl">
            {b.tiersNote}
          </p>
        </div>
      </div>
    </section>
  );
}
